module.exports = __webpack_public_path__ + "fonts/GT-Pressura-Mono-Bold.62bd457.woff2";